import http from 'utils/http';

export const changeReceiptNumber = (id, payload) => {
  return http.put(`cash/pos/receipt-no/${id}`, payload);
};

export const getCCODLiabilityAmount = (starId) => {
  return http.get(`cash/calculate-ccod-star-liabilities/${starId}`);
};
